import React from 'react';

import { useTranslation } from 'providers/GILT.provider';

const TextRebook = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TextRebook">
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section3DescriptionPart2')}
      </div>
    </div>
  );
};

export default TextRebook;
